// extracted by mini-css-extract-plugin
export default {"scrollableBar":"AllaCarta_scrollableBar__Owbld"};